import React, {useEffect, useState } from 'react'
import {Link, useParams} from "react-router-dom"
import companyLogo from'../../assets/logo/logo-print.png';
import "./Print.css";

export const  formatPhoneNumber = (phoneNumberString) => {
  
   var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
   var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
   if (match) {
     return '(' + match[1] + ') ' + match[2] + '-' + match[3];
   }
   return phoneNumberString;
 }

 export const formatDate = (date) => {
   const dateArray = date.split('-');
   const newDate = dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
   return newDate;
 }
 
function Print() {
   const {id, customerName, customerAddress, phone, date, orderNumber, orders, salesTax, deposit, type, eventDate, dueDate} = JSON.parse( useParams().printObj);

   const [total, setTotal] = useState(0);

   let SUBTOTAL = 0;
   let DISCOUNT = 0;
   const addUpTotal = (price, quantity, discount) => {
      const tempValue = (parseFloat(price) * parseFloat(quantity) * (100 - parseFloat(discount)) / 100);
      const tempDiscount = (parseFloat(price) * parseFloat(quantity) * (parseFloat(discount)) / 100);
      DISCOUNT = DISCOUNT + tempDiscount;
      SUBTOTAL = SUBTOTAL + tempValue;
      return tempValue;
   }

   useEffect(() => {

      let temp = 0;
      orders && orders.forEach(element => {temp +=(~~element.quantity * ~~element.price)});
      setTotal(temp);


      if (total !== 0) {
         window.print();
         }   
   }, [total, orders]);

  return (
    <div className="container ">  
       <div className="col-md-12">
          <div className="invoice">
             <div className="invoice-company text-inverse f-w-600" >
               <div className="logo-print">
                  <img src={companyLogo} className="user_image" alt="logo"/>
               </div>
                <span className={true ? "pull-right" : "hidden-print"} >
                <Link to={id ? `/orders/${id}` : '/alterations' } className="btn btn-sm btn-white m-b-10 p-l-5">
                  <i className="fa fa-file t-plus-1 text-danger fa-fw fa-lg">Back</i> </Link><br/>
                </span>                       
             </div>
             Order #{orderNumber ? orderNumber : ""}<br/>
             <div className="invoice-header">
                <div className="invoice-from">
                   <address className="m-t-5 m-b-5">
                      <strong className="text-inverse">IN STYLE BOUTIQUE</strong><br/>
                      14551 Ventura Blvd<br/>
                      Sherman Oaks, 91403<br/>
                      Phone: (818) 906-3016<br/>
                      IG: Instyle.boutique<br/>
                   </address>
                </div>
                <div className="invoice-to">
                   <address className="m-t-5 m-b-5">
                      <strong className="text-inverse">{customerName ? customerName : ""}</strong><br/>
                      {phone ? formatPhoneNumber(phone) : ""}<br/>
                      {date ? ( formatDate(date)) : ""}<br/>
                      {/* {customerAddress ? customerAddress : ""} */}
                      {eventDate && ("Due: " + formatDate(eventDate))}
                      {dueDate && ("Due: " + formatDate(dueDate))}
                   </address>
                </div>
             </div>
             <div className="invoice-content">
                <div className="table-responsive" >
                   <table className="table table-invoice" >
                      <thead >
                         <tr>
                            <th className="text-center" width={id ? "40%" : "30%"}>{id ? "ORDER" : "ALTERATION"} DESCRIPTION</th>
                            <th className="text-center" width={id ? "10%" : "10%"}>RATE</th>
                            <th className="text-center" width={id ? "10%" : "5%"}>QTY</th>
                            {id && <th className="text-center" width="10%">DISCOUNT</th>}
                            <th className="text-right" width={id ? "30%" : "15%"}>LINE TOTAL</th>
                            {/* <th className="text-center" width="30%">LINE TOTAL</th> */}
                         </tr>
                      </thead>
                      <tbody>
                        {orders && orders.map((item) => {
                            return (
                                <tr key={item.orderNumber + item.style}>
                                <td className="text-center" style={{textAlign: "center"}}>
                                    <span className="text-inverse">{item.style ? item.style : ""}</span><br/>
                                    <small>{(item.company ? item.company : "") + " " +
                                            (item.color ? item.color : "") + " " +
                                            (item.USSize ? item.USSize : "") + " " +
                                            (item.EURSize ? item.EURSize : "") + " "}                             
                                    </small>
                                    </td>
                                    <td style={{textAlign: "center"}} className="text-center">${item.price ? parseFloat(item.price) : 0}</td>
                                    <td  style={{textAlign: "center"}} className="text-center">{item.quantity ? item.quantity : "1"}</td>
                                    {id && <td  style={{textAlign: "center"}} className="text-center">{item.discount ? (item.discount+"%") : "0%"}</td>}
                                    <td  style={{textAlign: "center"}} className="text-center">${(addUpTotal(item.price,item.quantity,item.discount)).toFixed(2)}</td>
                                </tr>
                            );
                        })}
                      </tbody>
                   </table>
                </div>
                <div className="invoice-price">
                   <div className="invoice-price-left">
                      <div className="invoice-price-row">
                        {id && <div className="sub-price">
                            <small>Discount</small>
                            <span className="text-inverse">${DISCOUNT.toFixed(2)}</span>
                         </div>}
                         <div className="sub-price">
                            <small>Subtotal</small>
                            <span className="text-inverse">{"$"+SUBTOTAL.toFixed(2)}</span>
                         </div>
                         
                          <div className="sub-price">
                            <small>Sales Tax</small>
                            {
                              salesTax==="on" ?
                            <span className="text-inverse">{"$"+ (SUBTOTAL*9.5/100).toFixed(2)}</span> :
                            <span className="text-inverse">${(0).toFixed(2)}</span>
                            }
                         </div>
                         {deposit && deposit !== "0" && (
                         <div className="sub-price">
                            <small>Deposit</small>
                            <span className="text-inverse">{"$"+ (Number(deposit)).toFixed(2)}</span>
                         </div>
                         )
                         }



                      </div>
                   </div>
                   <div className="invoice-price-right">
                      <small>TOTAL</small> 
                      <div style={{textAlign: "center"}}>
                        {
                           salesTax==="on" ?
                           <span className="f-w-600">{"$"+ (SUBTOTAL*109.5/100).toFixed(2)}</span> :
                           <span className="f-w-600">{"$"+ (SUBTOTAL).toFixed(2)}</span>
                        }
                        
                        
                      </div>
                  
                   </div>
          
                </div>
      
             </div>
               { type !== "alteration" &&
               <div className="ba fr" style={{width: "140px", height:"41px"}}>
               <div>
                  <small className="ml1">Balance</small><br/>
                  <div className="tc ">
                     {
                        salesTax==="on" ?
                        <span className="f-w-600">{"$"+ (SUBTOTAL*109.5/100 - Number(deposit)).toFixed(2)}</span> :
                        <span className="f-w-600">{"$"+ (SUBTOTAL - Number(deposit)).toFixed(2)}</span>
                     }
                  </div>
               </div>
               </div>}


             <div className="invoice-note mt4">
               <br/> <br/>
               **No Refunds**
                all sales are final, deposits are non-refundable.
               <br/>
                * If you have any questions concerning this invoice, contact (818) 906-3016
             </div>
             <div className="invoice-footer">
                <p className="text-center m-b-5 f-w-600">
                   THANK YOU FOR YOUR PURCHASE <br/>
                </p>
                <p className="text-center">
                   <span className="m-r-10"><i className="fa fa-fw fa-lg fa-envelope"></i> In Style Boutique</span>
                </p>
             </div>
          </div>
       </div>
    </div>
  )
}

export default Print